module.exports = __webpack_public_path__ + "img/interational_shipping_img_1.362b00e3.png";